import React, { useEffect, useState } from "react"
import { useAppDispatch } from "../app/store"
import { setNewUserdemo } from "../features/Auth/authSlice"
import Spinner from "react-bootstrap/Spinner"

const StorylaneEmbed: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true) // State to manage visibility
  const [loading, setLoading] = useState(true) // State to manage iframe loading

  const dispatch = useAppDispatch()

  useEffect(() => {
    // Create the script element
    const script = document.createElement("script")
    script.src = "https://js.storylane.io/js/v2/storylane.js"
    script.async = true

    // Append the script to the document body
    document.body.appendChild(script)

    // Cleanup function to remove the script when the component unmounts
    return () => {
      document.body.removeChild(script)
    }
  }, [])

  // Function to handle close button click
  const handleClose = () => {
    dispatch(setNewUserdemo(null as any))
    setIsVisible(false)
  }

  // Only render the embed if it is visible
  if (!isVisible) return null

  const spinnerStyles: React.CSSProperties = {
    color: "#F475A4",
    width: "40px",
    height: "40px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 10001,
  }

  return (
    <div
      className="sl-embed-container"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        margin: 0,
        padding: 0,
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#fff",
        overflow: "hidden",
      }}
    >
      {loading && <Spinner animation="grow" style={spinnerStyles} />}
      {/* Close Button */}
      <button
        onClick={handleClose}
        style={{
          position: "absolute",
          top: "15px",
          right: "20px",
          padding: "10px 20px",
          fontSize: "16px",
          fontWeight: "600",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          zIndex: 10002,
          backgroundColor: "#F475A4",
          color: "#fff",
          boxShadow: "0 4px 12px rgba(244, 117, 164, 0.3)",
          transition: "all 0.2s ease",
        }}
        onMouseOver={(e) => {
          e.currentTarget.style.backgroundColor = "#e06592"
          e.currentTarget.style.transform = "translateY(-1px)"
        }}
        onMouseOut={(e) => {
          e.currentTarget.style.backgroundColor = "#F475A4"
          e.currentTarget.style.transform = "translateY(0)"
        }}
      >
        Skip
      </button>

      <div
        className="sl-embed"
        style={{
          position: "relative",
          width: "80%",
          height: "0",
          paddingBottom: "43%",
          maxHeight: "90vh",
          backgroundColor: "#fff",
          overflow: "hidden",
          borderRadius: "12px",
          boxShadow: loading ? "none" : "0 10px 30px rgba(0,0,0,0.1)",
        }}
      >
        <iframe
          loading="lazy"
          src="https://app.storylane.io/demo/f4dbqmcz7hjv"
          name="sl-embed"
          allow="fullscreen"
          allowFullScreen
          onLoad={() => setLoading(false)}
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            border: "none",
            visibility: loading ? "hidden" : "visible",
            opacity: loading ? 0 : 1,
            transition: "opacity 0.5s ease",
          }}
        ></iframe>
      </div>
    </div>
  )
}

export default StorylaneEmbed
